export default String.raw`
<div class="message-popup-background container-to-delete-js">
	<div class="change-data-container employee">
		<div class="data-form">
			<div class="data-form__header">
				{{ translations.LockEmployeeTitle }}
				<button class="close-button cancel-js" aria-label="{{ translations.Close }}">
					<svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg> 
				</button>
			</div>
			<div class="data-form__info">
                {{ translations.LockEmployeeInfo }}
			</div>
			<div class="buttons-container short">
				<button class="pure-button cancel-js">{{ translations.Cancel }}</button>
				<button class="primary-action-button lock closing-modal-mobile-js toggle-employee-js" data-container=".employees-list-view-js">
					{{ translations.LockEmployee }}
				</button>
			</div>
		</div>
	</div>
</div>
`